// extracted by mini-css-extract-plugin
export default {"pageContainer":"Yearbook_pageContainer__nnGCj"};